module.exports = __webpack_public_path__ + "static/img/logo_bandera.8753328f.jpg";